import script from "./DeleteSelectTaskItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteSelectTaskItem.vue?vue&type=script&setup=true&lang=js"

import "./DeleteSelectTaskItem.vue?vue&type=style&index=0&id=42a3d6ad&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a3d6ad"]])

export default __exports__